import {
	Box,
	Typography,
	LinearProgress,
} from "@mui/material";

const WebFooter = ({percentage}) => {
	return (
        
        <Box sx={{ backgroundColor: "#016d7c", px: 10, py: 0.2, position: "absolute", bottom: 0, width: "100%"}}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ minWidth: 140 }}>
                    <Typography sx={{ 
                        color: "white",
                        fontSize: "1.1rem",
                    }}>
                        Quiz Progress:
                    </Typography>
                </Box>
                <Box sx={{ width: "100%", mr: 1 }}>
                    <LinearProgress
                        variant="determinate"
                        sx={{
                            height: 10,
                            "&.MuiLinearProgress-colorPrimary": {
                                backgroundColor: "white!important",
                            },
                        }}
                        value={percentage}
                    />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography sx={{ 
                        color: "white",
                        fontSize: "1.1rem",
                    }}>{percentage?.toFixed(0)}%</Typography>
                </Box>
            </Box>
        </Box>
	);
};

export default WebFooter;
